var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLunettesDeScurit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_13",
    "data-name": "Calque 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1227 773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-4,.cls-6{fill:#b7b7b7;}.cls-3{opacity:0.19;}.cls-4{opacity:0.44;}.cls-5{fill:#0c0c0c;}.cls-7{fill:#595959;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-387 -584)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474,1300s-32-37-22-128,43-107,58-132S621,902,676,879c0-34,55-65,55-65s191-118,364-105c58,8,152,62.23,208,59,52-3,97-24,140-12s63,32,72,53,38,127,9,255c-5.14,28.9-49.87,41.3-93.15,31.64-24.1-5.38-29.75-29.61-45.85-49.64-79,16-135,53-157,79s-148.61,124.32-190,151c-45,29-54,33-81,27s20.38-17.88,58-42c39-25,84-53,146-110s177-127,198-138c-14-27-41-76-37-122-23,0-21,27-33,51s-45,107-105,133c-25,10-102-8-140-11s-185-32-297-24c-27,3-56-55-57-84-45,30-83,32-108,51s-75,60-86,96-25,120-17,153,20,40,11,45A14.31,14.31,0,0,1,474,1300Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lunettes de s\xE9curit\xE9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M474,1300s-32-37-22-128,43-107,58-132S621,902,676,879c0-34,55-65,55-65s191-118,364-105c58,8,152,62.23,208,59,52-3,97-24,140-12s63,32,72,53,38,127,9,255c-5.14,28.9-49.87,41.3-93.15,31.64-24.1-5.38-29.75-29.61-45.85-49.64-79,16-135,53-157,79s-148.61,124.32-190,151c-45,29-54,33-81,27s20.38-17.88,58-42c39-25,84-53,146-110s177-127,198-138c-14-27-41-76-37-122-23,0-21,27-33,51s-45,107-105,133c-25,10-102-8-140-11s-185-32-297-24c-27,3-56-55-57-84-45,30-83,32-108,51s-75,60-86,96-25,120-17,153,20,40,11,45A14.31,14.31,0,0,1,474,1300Z",
    transform: "translate(-387 -584)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M614,584v585h987V584Zm910.09,476.62c-5.1,28.3-49.52,40.44-92.48,31-23.93-5.27-29.54-29-45.52-48.61-12.09-14-17.09-20-25.82-32.32-13.9-26.44-40.7-74.42-36.73-119.47-22.84,0-20.85,26.44-32.77,49.95s-44.67,104.78-104.25,130.24c-24.82,9.79-101.26-7.84-139-10.77s-183.68-31.34-294.88-23.51c-26.8,2.94-57.58-55.81-56.59-82.25s-15.88-41.13-13.9-75.41,54.61-63.65,54.61-63.65S926.4,700.25,1098.16,713c57.59,7.83,150.93,60.94,206.51,57.78,51.63-2.94,96.31-23.51,139-11.76s62.55,31.34,71.48,51.91S1552.88,935.27,1524.09,1060.62Z",
    transform: "translate(-387 -584)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M690,956s72-46,67-77-3-42.18-103,13.91S426,1032,426,1032l-39,293,144,5,41-196Z",
    transform: "translate(-387 -584)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1359,1013l26,33s-385,311-392,311-124-59-124-59l70-82Z",
    transform: "translate(-387 -584)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1224.17,1046.41S1216,946,1256,897s73-46,82-37,45,23,61,123,3,34,9,57,12,46,23,52-12,8-12,8l-74.34-113L1314,931l-33,82Z",
    transform: "translate(-387 -584)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1498.76,1091.65s-38.94,19.74-38.85-85S1467,902,1475,859s8-84-32-91-96-17-96-17l133-35s69,34,87,59,47,104,47,104v229h-96Z",
    transform: "translate(-387 -584)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1399,992l10,37s84-29,87-56,2-69-12-58S1417,984,1399,992Z",
    transform: "translate(-387 -584)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M530,1037S637,910,745,891C612,953,530,1037,530,1037Z",
    transform: "translate(-387 -584)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunettesDeScurit);
export default __webpack_public_path__ + "static/media/lunettes_de_sécurité.d3ee19eed38f0c0da0900fc1eb887e62.svg";
export { ForwardRef as ReactComponent };